import React from 'react';
import { formatDateTime } from '../../utils/format';

// 문의 스레드 — 사장님/슈퍼 양쪽이 같은 컴포넌트를 쓴다.
// mySide 는 "이 화면의 주인이 어느 쪽인가"다('shop' 또는 'admin').
// 내 글은 오른쪽, 상대 글은 왼쪽으로 붙어 카톡처럼 읽힌다.
// onSelect 를 주면 각 메시지 본문이 '가릴 범위' 선택 대상이 된다(슈퍼 화면만).
// 사장님 화면에선 안 넘기므로 아무 동작도 붙지 않는다.
const SupportThread = ({ messages = [], mySide = 'shop', onSelect = null }) => {
    if (messages.length === 0) {
        return <p className="text-muted mb-0">내용이 없습니다.</p>;
    }
    return (
        <div className="sp-thread">
            {messages.map(m => {
                const mine = m.author_type === mySide;
                return (
                    <div key={m.id} className={`sp-msg ${mine ? 'sp-msg-mine' : 'sp-msg-other'}`}>
                        <div className="sp-msg-head">
                            <span className="sp-msg-author">
                                {m.author_type === 'admin' ? (m.author_name || '운영팀') : (m.author_name || '사장님')}
                                {m.author_type === 'admin' && <span className="sp-msg-tag">운영팀</span>}
                            </span>
                            <span className="sp-msg-time">{formatDateTime(m.created_at)}</span>
                        </div>
                        {/* 사용자 입력 그대로 — 줄바꿈만 살린다. HTML 로 해석하지 않는다.
                            본문을 **단일 텍스트 노드**로 두는 게 중요하다: 운영팀의 수동
                            가리기가 selection 오프셋을 그대로 쓰기 때문에, 중간에 <span>
                            같은 걸 끼우면 좌표가 서버의 문자열 인덱스와 안 맞는다. */}
                        <div className="sp-msg-body"
                            onMouseUp={onSelect ? () => onSelect(m) : undefined}
                            onTouchEnd={onSelect ? () => onSelect(m) : undefined}>{m.body}</div>
                        {/* 가린 사실을 사장님 화면에도 띄운다. 이게 없으면 "모르게 바뀌었다"
                            가 되고, 분쟁 소지의 대부분이 거기서 나온다. 담당자 개인은
                            노출하지 않는다 — 회사가 한 일이다. */}
                        {m.redacted_at && (
                            <div className="sp-redacted mt-1">
                                {formatDateTime(m.redacted_at)} 운영팀이 개인정보 보호를 위해 본문의 일부를 가렸습니다.
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default SupportThread;
